export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"facebook-domain-verification","content":"tyg95e6cfhy9zvptbojg7yi039v1x3"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico","sizes":"any"},{"rel":"icon","type":"image/svg+xml","href":"/icon.svg"}],"style":[],"script":[{"key":"gtm-consent-script","hid":"gtm-consent-script","innerHTML":"\n      window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('consent', 'default', {\n        'ad_storage': 'denied',\n        'ad_user_data': 'denied',\n        'ad_personalization': 'denied',\n        'analytics_storage': 'granted',\n        'region': ['AE', 'CA', 'CH', 'HK', 'JP', 'SG']\n      });\n      gtag('consent', 'default', {\n        'ad_storage': 'granted',\n        'ad_user_data': 'granted',\n        'ad_personalization': 'granted',\n        'analytics_storage': 'granted',\n        'region': ['MX', 'US', 'US-CA']\n      });\n      gtag('consent', 'default', {\n        'ad_storage': 'denied',\n        'ad_user_data': 'denied',\n        'ad_personalization': 'denied',\n        'analytics_storage': 'denied'\n      });\n    ","tagPriority":"high"},{"key":"one-trust-script","hid":"one-trust-script","type":"text/javascript","src":"//cdn.cookielaw.org/scripttemplates/otSDKStub.js","data-domain-script":"0192d86c-04a9-7967-9a48-20d2b66f78e8"},{"key":"one-trust-optanon-script","innerHTML":"function OptanonWrapper() {\n        const bannerRejectBtn = document.getElementById('onetrust-reject-all-handler');\n        const bannerPcRefuseAlltBtn = document.querySelector('.ot-pc-refuse-all-handler');\n        const bannerPcSaveBtn = document.querySelector('.save-preference-btn-handler');\n\n        if(bannerRejectBtn){\n          bannerRejectBtn.addEventListener('click', function() {\n            setTimeout(() => {\n              location.reload();\n            }, 1000)\n          });\n        }\n        if(bannerPcRefuseAlltBtn){\n          bannerPcRefuseAlltBtn.addEventListener('click', function() {\n            setTimeout(() => {\n              location.reload();\n            }, 1000)\n          });\n        }\n        if(bannerPcSaveBtn){\n          bannerPcSaveBtn.addEventListener('click', function() {\n            setTimeout(() => {\n              location.reload();\n            }, 1000)\n          });\n        }\n      }","type":"text/javascript"},{"key":"gtm-csp-nonce-script","hid":"gtm-csp-nonce-script","id":"gtmCspNonceScript","innerHTML":"\n      window.dataLayer = window.dataLayer || [];\n      const nonceElem = document.querySelector('script[nonce]');\n      if (nonceElem && nonceElem.nonce) {\n        dataLayer.push({\n          'cspNonce': nonceElem.nonce\n        });\n      }\n    ","tagPriority":"high"},{"key":"gtm-script","hid":"gtm-script","id":"gtmScript","innerHTML":"\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=afdbAXrh3-yNk9m3Wq79uw&gtm_preview=env-1';var n=d.querySelector('[nonce]');\n      n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','GTM-575TF4H');\n    ","tagPriority":"high"}],"noscript":[{"key":"gtm-noscript","hid":"gtm-noscript","innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-575TF4H&gtm_auth=afdbAXrh3-yNk9m3Wq79uw&gtm_preview=env-1\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>","tagPriority":"high"}],"title":"Adyen"}

export const appBuildAssetsDir = "/main_nuxt/"

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true